var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcJob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D16",
    fillRule: "evenodd",
    d: "M22.667 28H9.333V9.333h1.334v-2A3.333 3.333 0 0114 4h4a3.333 3.333 0 013.333 3.333v2h1.334V28zM14 6.667a.667.667 0 00-.667.666v2h5.334v-2A.667.667 0 0018 6.667h-4z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D16",
    d: "M25.333 9.333V28a4 4 0 004-4V13.333a4 4 0 00-4-4zM6.667 9.333a4 4 0 00-4 4V24a4 4 0 004 4V9.333z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcJob);
export default __webpack_public_path__ + "static/media/icon_ic_job.45a3406ba435ce1be1805b8db333c246.svg";
export { ForwardRef as ReactComponent };